document.documentElement.classList.remove("no-js");

(function () {
  var header = document.querySelector("[data-site-header]");
  var toggle = document.getElementById("SiteMenuToggle");
  var overlay = document.getElementById("SiteMenuOverlay");
  var drawer = document.getElementById("SiteMenuDrawer");
  if (!header || !toggle || !overlay || !drawer) return;

  var mqDesktop = window.matchMedia("(min-width: 901px)");
  var promo = document.querySelector(".promo-bar");
  var main = document.getElementById("MainContent");
  var firstMainEl = main && main.firstElementChild;
  var overHero =
    firstMainEl &&
    firstMainEl.matches &&
    firstMainEl.matches(".atf--homepage, .home2m, .home3, .page-about, .page-proc");

  document.body.classList.toggle("site-header-over-hero", !!overHero);

  function updateHeaderState() {
    var promoHeight = promo ? promo.offsetHeight : 0;
    var headerTop = Math.max(promoHeight - window.scrollY, 0);
    document.documentElement.style.setProperty("--site-header-top", headerTop + "px");
    document.documentElement.style.setProperty("--site-header-space", header.offsetHeight + "px");
    document.body.classList.toggle("site-header-solid", window.scrollY > 12);
  }

  function setNavOpen(open) {
    var els = drawer.querySelectorAll("a[href], button");
    document.body.classList.toggle("site-nav-open", open);
    document.documentElement.classList.toggle("site-nav-open", open);
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    drawer.setAttribute("aria-hidden", open ? "false" : "true");
    els.forEach(function (el) {
      if (open) el.removeAttribute("tabindex");
      else el.setAttribute("tabindex", "-1");
    });
  }

  setNavOpen(false);
  updateHeaderState();
  window.addEventListener("scroll", updateHeaderState, { passive: true });

  toggle.addEventListener("click", function () {
    setNavOpen(!document.body.classList.contains("site-nav-open"));
  });

  overlay.addEventListener("click", function () {
    setNavOpen(false);
  });

  drawer.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest("a[href]");
    if (a) setNavOpen(false);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && document.body.classList.contains("site-nav-open")) {
      setNavOpen(false);
      toggle.focus();
    }
  });

  function onResize() {
    updateHeaderState();
    if (mqDesktop.matches && document.body.classList.contains("site-nav-open")) {
      setNavOpen(false);
    }
  }
  window.addEventListener("resize", onResize);
  if (mqDesktop.addEventListener) {
    mqDesktop.addEventListener("change", onResize);
  }
})();

(function () {
  var root = document.querySelector("[data-proc-root]");
  if (!root) return;
  var navBtns = root.querySelectorAll("[data-proc-nav]");
  var panels = root.querySelectorAll("[data-proc-panel]");
  navBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var id = btn.getAttribute("data-proc-nav");
      navBtns.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle("is-active", on);
        if (on) b.setAttribute("aria-current", "true");
        else b.removeAttribute("aria-current");
      });
      panels.forEach(function (p) {
        p.classList.toggle("is-active", p.getAttribute("data-proc-panel") === id);
      });
    });
  });
})();

(function () {
  var form = document.getElementById("ContactForm");
  if (!form) return;
  form.addEventListener(
    "submit",
    function () {
      var first = form.querySelector("#ContactForm-name");
      var last = document.getElementById("ContactForm-last");
      if (!first || !last || !last.value.trim()) return;
      var a = (first.value || "").trim();
      var b = last.value.trim();
      first.value = (a + " " + b).trim();
    },
    true
  );
})();

(function () {
  document.addEventListener(
    "click",
    function (e) {
      var link = e.target.closest && e.target.closest("a.open-booking-widget");
      if (!link) return;
      var href = link.getAttribute("href");
      if (href === "#" || href === "") {
        e.preventDefault();
      }
    },
    true
  );
})();
